/* =========================================================================
   Priskel — Stack & Save progress bar + Complete the Look
   -------------------------------------------------------------------------
   A. STACK BAR   Live cart-quantity tiers. 2 pieces = 10%, 3+ = 15%.
                  Reads /cart.js, re-reads on every cart event, shows the
                  real rupee saving against the current cart subtotal.
   B. THE LOOK    Pulls live products from the curated stack collections and
                  lets a shopper add a second piece without leaving the PDP.
                  Each card shows the selling price with the MRP struck
                  through beside it, matching the PDP price block.

   IMPORTANT: the STACKSAVE discount does not currently exist in Shopify.
   Do not publish this theme until the discount is real in the Fastrr
   checkout, or the bar will promise a saving that never applies.

   To remove: delete this file and its tag in snippets/scripts.liquid.
   ========================================================================= */
(function () {
  if (window.__pkStackInit) return;
  window.__pkStackInit = true;

  var TIER_2 = 10;   /* percent off at 2 pieces  */
  var TIER_3 = 15;   /* percent off at 3+ pieces */
  var CODE   = 'STACKSAVE';

  var COLLECTIONS = {
    necklace:   { handle: 'the-layered-edit',  label: 'Layers that sit together' },
    bracelets:  { handle: 'the-wrist-stack',   label: 'Build the wrist' },
    _default:   { handle: 'build-your-stack',  label: 'Made to be worn together' }
  };

  function money(paise) {
    return '₹' + Math.round(paise / 100).toLocaleString('en-IN');
  }

  /* products.json returns prices as rupee strings, not paise. */
  function inr(value) {
    var n = parseFloat(value);
    if (!isFinite(n)) return '';
    return '₹' + Math.round(n).toLocaleString('en-IN');
  }

  function getCart() {
    return fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.ok ? r.json() : null; })
      .catch(function () { return null; });
  }

  /* ----------------------------- A. STACK BAR ---------------------------- */

  function barMarkup() {
    var el = document.createElement('div');
    el.className = 'pk-stack';
    el.setAttribute('data-pk-stack', '');
    el.innerHTML =
      '<div class="pk-stack__head">' +
        '<span class="pk-stack__label">Stack &amp; Save</span>' +
        '<span class="pk-stack__saving" data-pk-saving hidden></span>' +
      '</div>' +
      '<p class="pk-stack__msg" data-pk-msg></p>' +
      '<div class="pk-stack__track" role="presentation">' +
        '<div class="pk-stack__fill" data-pk-fill></div>' +
        '<span class="pk-stack__node" data-pk-node="2"><i></i><b>2 pieces<br>' + TIER_2 + '% off</b></span>' +
        '<span class="pk-stack__node" data-pk-node="3"><i></i><b>3+ pieces<br>' + TIER_3 + '% off</b></span>' +
      '</div>';
    return el;
  }

  function renderBar(bar, cart) {
    var qty = cart ? cart.item_count : 0;
    var total = cart ? cart.total_price : 0;
    var msg = bar.querySelector('[data-pk-msg]');
    var fill = bar.querySelector('[data-pk-fill]');
    var saving = bar.querySelector('[data-pk-saving]');
    var n2 = bar.querySelector('[data-pk-node="2"]');
    var n3 = bar.querySelector('[data-pk-node="3"]');

    var pct = 0, amount = 0, text = '';

    if (qty >= 3) {
      pct = TIER_3;
      text = 'Best value unlocked. Apply code <b>' + CODE + '</b> at checkout.';
    } else if (qty === 2) {
      pct = TIER_2;
      text = 'Add 1 more piece to save ' + TIER_3 + '% instead.';
    } else if (qty === 1) {
      text = 'Add 1 more piece and save ' + TIER_2 + '% on both.';
    } else {
      text = 'Add 2 pieces and save ' + TIER_2 + '%. Add 3 and save ' + TIER_3 + '%.';
    }

    amount = Math.round(total * pct / 100);

    msg.innerHTML = text;
    fill.style.width = (qty >= 3 ? 100 : qty === 2 ? 60 : qty === 1 ? 26 : 0) + '%';
    n2.classList.toggle('is-on', qty >= 2);
    n3.classList.toggle('is-on', qty >= 3);
    bar.classList.toggle('is-unlocked', qty >= 2);

    if (pct > 0 && amount > 0) {
      saving.textContent = 'You save ' + money(amount);
      saving.hidden = false;
    } else {
      saving.hidden = true;
    }
  }

  function mountBar() {
    var btn = document.querySelector('.hdt-product-info__item.hdt-product__buy-button');
    if (!btn || document.querySelector('[data-pk-stack]')) return null;
    var bar = barMarkup();
    btn.parentNode.insertBefore(bar, btn);
    return bar;
  }

  /* -------------------------- B. COMPLETE THE LOOK ------------------------ */

  function currentProduct() {
    try {
      var m = window.ShopifyAnalytics && window.ShopifyAnalytics.meta;
      if (m && m.product) return { id: m.product.id, type: (m.product.type || '').toLowerCase() };
    } catch (e) {}
    return { id: null, type: '' };
  }

  function pickCollection(type) {
    if (type.indexOf('necklace') > -1) return COLLECTIONS.necklace;
    if (type.indexOf('bracelet') > -1) return COLLECTIONS.bracelets;
    return COLLECTIONS._default;
  }

  function sized(src, w) {
    if (!src) return '';
    return src + (src.indexOf('?') > -1 ? '&' : '?') + 'width=' + w;
  }

  function cardMarkup(p) {
    var v = p.variants && p.variants[0];
    if (!v) return '';
    var img = (p.images && p.images[0]) ? p.images[0].src : '';
    var now = parseFloat(v.price);
    var was = v.compare_at_price ? parseFloat(v.compare_at_price) : 0;
    var showWas = isFinite(was) && was > now;
    return '' +
      '<li class="pk-look__item">' +
        '<a class="pk-look__media" href="/products/' + p.handle + '" tabindex="-1" aria-hidden="true">' +
          (img ? '<img src="' + sized(img, 300) + '" alt="" loading="lazy" width="150" height="150">' : '') +
        '</a>' +
        '<a class="pk-look__title" href="/products/' + p.handle + '">' + p.title + '</a>' +
        '<span class="pk-look__price">' +
          '<span class="pk-look__now">' + inr(now) + '</span>' +
          (showWas ? '<s class="pk-look__was">' + inr(was) + '</s>' : '') +
        '</span>' +
        '<button type="button" class="pk-look__add" data-pk-add="' + v.id + '">Add</button>' +
      '</li>';
  }

  function mountLook() {
    var btn = document.querySelector('.hdt-product-info__item.hdt-product__buy-button');
    if (!btn || document.querySelector('[data-pk-look]')) return;

    var prod = currentProduct();
    var col = pickCollection(prod.type);

    var wrap = document.createElement('div');
    wrap.className = 'pk-look';
    wrap.setAttribute('data-pk-look', '');
    wrap.innerHTML =
      '<div class="pk-look__head">' +
        '<span class="pk-look__label">Complete the look</span>' +
        '<a class="pk-look__all" href="/collections/' + col.handle + '">See all</a>' +
      '</div>' +
      '<p class="pk-look__sub">' + col.label + '</p>' +
      '<ul class="pk-look__list" data-pk-look-list></ul>';

    btn.parentNode.insertBefore(wrap, btn.nextSibling);

    fetch('/collections/' + col.handle + '/products.json?limit=10', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (data) {
        if (!data || !data.products) { wrap.remove(); return; }
        var items = data.products.filter(function (p) {
          if (prod.id && String(p.id) === String(prod.id)) return false;
          return p.variants && p.variants.some(function (v) { return v.available; });
        }).slice(0, 6);
        if (!items.length) { wrap.remove(); return; }
        wrap.querySelector('[data-pk-look-list]').innerHTML = items.map(cardMarkup).join('');
      })
      .catch(function () { wrap.remove(); });
  }

  /* ------------------------------- wiring -------------------------------- */

  function refresh() {
    var bar = document.querySelector('[data-pk-stack]');
    if (!bar) return;
    getCart().then(function (cart) { renderBar(bar, cart); });
  }

  document.addEventListener('click', function (e) {
    var add = e.target.closest && e.target.closest('[data-pk-add]');
    if (!add) return;
    e.preventDefault();
    var id = add.getAttribute('data-pk-add');
    var original = add.textContent;
    add.disabled = true;
    add.textContent = 'Adding…';
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: Number(id), quantity: 1 })
    })
      .then(function (r) {
        if (!r.ok) throw new Error('add failed');
        add.textContent = 'Added';
        add.classList.add('is-added');
        refresh();
        document.dispatchEvent(new CustomEvent('cart:reload'));
        document.dispatchEvent(new CustomEvent('cart:update'));
        setTimeout(function () {
          add.textContent = original;
          add.classList.remove('is-added');
          add.disabled = false;
        }, 2200);
      })
      .catch(function () {
        add.textContent = 'Try again';
        add.disabled = false;
        setTimeout(function () { add.textContent = original; }, 2000);
      });
  });

  function boot() {
    if (!document.querySelector('.hdt-product-info__item.hdt-product__buy-button')) return;
    var bar = mountBar();
    mountLook();
    if (bar) refresh();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  ['cart:update', 'cart:reload', 'cart:count:update'].forEach(function (evt) {
    document.addEventListener(evt, function () { setTimeout(refresh, 250); });
  });
  document.addEventListener('shopify:section:load', function () { setTimeout(boot, 120); });

  var t = null;
  if (typeof MutationObserver !== 'undefined') {
    new MutationObserver(function () {
      clearTimeout(t);
      t = setTimeout(boot, 250);
    }).observe(document.body, { childList: true, subtree: true });
  }
})();